import React, { useEffect, useState } from "react";
import { Box, Typography, Container } from "@mui/material";
import "./HeroSection.css";
import { getHeroSection } from "../../api/heroSection";
import { useLanguage } from "../../context/LanguageContext";
import { ENV } from "../../config/env";

const HeroSection = () => {
  const [hero, setHero] = useState(null);
  const { language } = useLanguage();

  useEffect(() => {
    fetchHero();
  }, [language]);

const fetchHero = async () => {
  try {
    const data = await getHeroSection(language);

    console.log("FULL HERO DATA =>", data);

    console.log("DESKTOP IMAGE =>", data?.desktopImage);

    console.log("MOBILE IMAGE =>", data?.mobileImage);

    console.log(
      "DESKTOP URL =>",
      `${ENV.API_BASE_URL}${data?.desktopImage?.url}`
    );

    console.log(
      "MOBILE URL =>",
      `${ENV.API_BASE_URL}${data?.mobileImage?.url}`
    );

    setHero(data);

  } catch (err) {
    console.error("Hero fetch error", err);
  }
};

  if (!hero) return null;

  return (
    <Box className="hero-root">

      {/* Desktop Image */}
      <img
        src={`${ENV.API_BASE_URL}${hero?.desktopImage?.url}`}
        alt="Hero Banner"
        className="hero-image desktop-image"
      />

      {/* Mobile Image */}
      <img
        src={`${ENV.API_BASE_URL}${hero?.mobileImage?.url}`}
        alt="Hero Banner Mobile"
        className="hero-image mobile-image"
      />

      <div className="hero-overlay"></div>

      <Container maxWidth="lg" className="hero-content">
        <Typography variant="h2" className="hero-title">
          {hero.title}
        </Typography>

        <Typography className="hero-subtitle">
          {hero.subtitle}
        </Typography>
      </Container>

    </Box>
  );
};

export default HeroSection;


// import React, { useEffect, useState } from "react";
// import { Box, Typography, Container } from "@mui/material";
// import "./HeroSection.css";
// import { getHeroSection } from "../../api/heroSection";
// import { useLanguage } from "../../context/LanguageContext";
// import { ENV } from "../../config/env";

// const HeroSection = () => {
//   const [hero, setHero] = useState(null);
//   const { language } = useLanguage();

//   useEffect(() => {
//     fetchHero();
//   }, [language]);

//   const fetchHero = async () => {
//     try {
//       const data = await getHeroSection(language);
//       setHero(data);
//     } catch (err) {
//       console.error("Hero fetch error", err);
//     }
//   };

//   if (!hero) return null;

//   return (
//     <Box className="hero-root">

//       {/* Desktop Image */}
//       <img
//         src={`${ENV.API_BASE_URL}/uploads/hero_img_09b9811cea.png`}
//         alt="Hero Banner"
//         className="hero-image desktop-image"
//       />

//       {/* Mobile Image */}
//       <img
//         src={`${ENV.API_BASE_URL}/uploads/hero_mobile_img_cd8c2ffa96.png`}
//         alt="Hero Banner Mobile"
//         className="hero-image mobile-image"
//       />

//       <div className="hero-overlay"></div>

//       <Container maxWidth="lg" className="hero-content">
//         <Typography variant="h2" className="hero-title">
//           {hero.title}
//         </Typography>

//         <Typography className="hero-subtitle">
//           {hero.subtitle}
//         </Typography>
//       </Container>
//     </Box>
//   );
// };

// export default HeroSection;